export const call = async (url: string, options?: RequestInit) => {
  const baseOptions: RequestInit = {}
  return await fetch(url, { ...baseOptions, ...options })
}
